<template>
  <form class="p-3" @submit.prevent="login">
    <div class="d-flex flex-column align-items-start pb-4">
      <label class="fw-bold pb-1" for="email" form_label>Username</label>
      <input
        class="form-control py-2"
        v-model="user.email"
        name="email"
        placeholder="Example: johndoe@gmail.com"
      />
    </div>
    <div class="d-flex flex-column align-items-start pb-4">
      <label class="fw-bold pb-1" for="password" form_label>Password</label>
      <input
        class="form-control py-2"
        v-model="user.password"
        name="password"
        placeholder="password"
      />
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <div class="pb-1">
        <button class="btn text-white fw-bolder" loginbtn>Login</button>
      </div>
      <button class="btn" type="button" @click="showPinLogin" loginoption>
        <small>login with pin</small>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "CredentialLoginComp",
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    showPinLogin() {
      this.$store.dispatch("login/setForm", "pinform");
    },
    login() {
      this.$store.dispatch("login/loginUser", {
        email: this.user.email,
        password: this.user.password,
      });
    },
  },
};
</script>

<style scoped>
[background] {
  background-color: var(--futurerent);
}
[form_label] {
  font-size: 14px;
}

form input {
  width: 350px;
}

[loginbtn] {
  background-color: var(--dark);
  font-size: 16px;
  padding: 8px 24px;
}
[loginbtn]:hover {
  background-color: blue;
}

[loginoption] {
  border: none;
  outline: none;
}
[loginoption] small {
  color: #0645ad;
  text-decoration: underline;
}
</style>
